export enum UnitForKey {
    area = 'Has',
    declared_area = 'Has'
}